import { TemplateName } from "../types";
import { NewlyNotReportingSingleTemplate } from "./singleTemplate";
export class NewlyNotReportingNJTemplate extends NewlyNotReportingSingleTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.NewlyNotReportingNJ;
    }
    text(params) {
        const { name, address, organizationName, reportingYear } = this.getSingleFacility(params);
        return `To whom it may concern,

As part of our commitment to environmental compliance and community safety, please find the attached Community Right to Know Reporting Exemption Form for the following facility:

${name}
${address}

This notification is filed by Encamp, Inc. on behalf of ${organizationName}.

This facility was previously a CRTK reporter and is no longer required to submit a report for Reporting Year ${reportingYear}. The attached exemption form has already been submitted to the NJDEP.

Encamp strives to maintain the most up to date information for our submissions. If our current information is incorrect or you have had any updates or changes, please email support@encamp.com and let us know. This will help us ensure that our records are maintained accurately on behalf of our customers.

${this.signature}`;
    }
}
//# sourceMappingURL=nj.js.map